
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 window.Vue = require('vue');

 import'./bulma';

 import'./script';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
//  var SocialSharing = require('vue-social-sharing');
//  Vue.use(SocialSharing);
/*-----------------General Components ---------------*/
import LazyLoad from './components/GeneralComponents/LazyLoad';
import SlotForm from './components/GeneralComponents/SlotForm';
import SlickAnimation from './components/GeneralComponents/slickCarouselAnimation';
import Slick from 'vue-slick';
import Carousel3d from 'vue-carousel-3d';
import VueTranslate from 'vue-translate-plugin';
import VueWindowSize from 'vue-window-size';
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import StarRating from 'vue-star-rating';
import NumberInput from './components/GeneralComponents/NumberInput';
import * as VueGoogleMaps from 'vue2-google-maps';
import {VueMasonryPlugin} from 'vue-masonry';
import RepeaterColor from './components/GeneralComponents/color-picker/RepeaterColor';
import Uploader from './components/GeneralComponents/Uploader';
import Dropzone from './components/GeneralComponents/Dropzone';
import VueQrcodeReader from "vue-qrcode-reader";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import Alert from './components/GeneralComponents/Alert';
import DatePicker from './components/GeneralComponents/DatePicker';
import TimePicker from './components/GeneralComponents/TimePicker';
import SearchPage from './components/GeneralComponents/SearchPage';
import VueLazyload from 'vue-lazyload'
import VueInstantSearch from 'vue-instantsearch';
/*-------------Site Components---------------*/
import StickyHeader from './components/SiteComponents/StickyHeader';
import MobileHeader from './components/SiteComponents/MobileHeader';
import Search from './components/SiteComponents/Search';
import ServicesSlider from './components/SiteComponents/ServicesSlider';
import CategoriesSlider from './components/SiteComponents/CategoriesSlider';
import Sponsers from './components/SiteComponents/Sponsers';
import About from './components/SiteComponents/About';
import Projects from './components/SiteComponents/Projects';
import Usage from './components/SiteComponents/Usage';
import Addresses from './components/SiteComponents/Addresses';
import News from './components/SiteComponents/News';
import SharePage from './components/SiteComponents/SharePage';
import ChooseColor from './components/SiteComponents/ChooseColor';
import AddService from './components/SiteComponents/AddService';
import BookNow from './components/SiteComponents/BookNow';
import SearchHeader from './components/SiteComponents/SearchHeader';
import AddMap from "./components/SiteComponents/AddMap";
import Notifications from "./components/SiteComponents/Notifications";


/*====Categories=====*/
import CategoriesPage from './components/SiteComponents/categories/CategoriesPage';
import MerchantsPage from './components/SiteComponents/categories/MerchantsPage';
import MerchantsSlider from './components/SiteComponents/categories/MerchantsSlider';
import Products from './components/SiteComponents/categories/Products';
import MerchantsProducts from './components/SiteComponents/categories/MerchantsProducts';

/*----------user----------*/
import UserProfile from './components/SiteComponents/user-profile/UserProfile';
import UserProducts from './components/SiteComponents/user-profile/UserProducts';
/*-------merchant-----------*/
import MerchantProfile from './components/SiteComponents/merchant-profile/MerchantProfile';
import MerchantOrders from './components/SiteComponents/merchant-profile/orders';
/*====auth=====*/
import ProjectsPage from './components/SiteComponents/projects/ProjectsPage';
import ProjectSlider from './components/SiteComponents/projects/ProjectSlider';


/*====auth=====*/
import Login from './components/SiteComponents/auth/login';
import Register from './components/SiteComponents/auth/Register';
import Reset from './components/SiteComponents/auth/Reset';


/*-------------USES---------------*/
Vue.use(Carousel3d);
Vue.use(VueTranslate);
Vue.use(VueWindowSize);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.use(VueMasonryPlugin);
Vue.use(VueQrcodeReader);
Vue.use(VueInstantSearch);
Vue.component('star-rating', StarRating);
Vue.component('lazy-load', LazyLoad);
Vue.component('uploader', Uploader);
Vue.component('add-map', AddMap);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('search', Search);
// Vue.component('notifications', Notifications);


Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyCphqOpGEPztIh5Mwuj-sOSyGXlyJatl1s",
    	libraries: "places" // necessary for places input
    }

});
Vue.use(VueLazyload, {
	preLoad: 100,
	error: '',
	loading: '/front/img/spinner.svg',
	attempt: 1,
	adapter: {
		loading (listender, Init) {
			listender.el.style.height = "100px";
		},
		loaded ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
            el.style.height= "auto";
        },
	}
})
// Vue.use(VeeValidate);


//  import Collapse from 'vue-bulma-collapse/src/Collapse'
//  import CollapseItem from 'vue-bulma-collapse/src/Item'
//  import Slick from 'vue-slick'
//  import VueTranslate from 'vue-translate-plugin';
// import VeeValidate from 'vee-validate';
//  import StarRating from 'vue-star-rating'
//  import { Tabs, TabPane } from 'vue-bulma-tabs'
//  import * as VueGoogleMaps from "vue2-google-maps";
//  import GoogleMap  from "./components/GoogleMap";
//  import AddMap  from "./components/AddMap";
//  import SearchModal  from "./components/SearchModal";
//  import SlideOut  from "./components/SlideOut";
//  import Messages  from "./components/messages";
//  import VueFormWizard from 'vue-form-wizard'
//  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
//  import NumberInput from '@chenfengyuan/vue-number-input';
//  import 'swiper/dist/css/swiper.css'
//  import swiper from './components/swiper/swiper'
//  import  swiperSlide from './components/swiper/slide.vue'
//  import VueTelInput from 'vue-tel-input'
//  import Toasted from 'vue-toasted'
//  import VueSlideBar from './components/VueSlideBar'
//  import Loader from './components/LoadingBar'

/*--------- our components-------*/
//  import SlotForm from './components/SlotForm'
//   import CopyLink from './components/CopyLink'
//  import BrandFilter from './components/BrandFilter'
//  import CategoryFilter from './components/CategoryFilter'
//  import Register from './components/Register'
//  import Profile from './components/Profile'
// import Newsletter from './components/Newsletter'
//  import Comments from './components/Comments'
// import OfferFilter from './components/OfferFilter'
// import Search from './components/Search'
// import SearchResults from './components/SearchResults'
// import MobileSearchResults from './components/MobileSearchResults'
// import AddRate from './components/AddRate'
// import AddAddress from  './components/AddAddress'
// import Checkout from  './components/Checkout'

// import VueWindowSize from 'vue-window-size';
// import VueInstantSearch from 'vue-instantsearch';

// Vue.use(VueInstantSearch);
// Vue.use(VueWindowSize);

//  Vue.use(Toasted, {
//  	duration: 5000
//  });
//  Vue.use(VueTelInput)
//  Vue.use(VueFormWizard)
//  Vue.use(VeeValidate);
//  Vue.use(VueTranslate);

//  Vue.use(VueGoogleMaps, {
//  	load: {
//  		key: "AIzaSyCphqOpGEPztIh5Mwuj-sOSyGXlyJatl1s",
//     	libraries: "places" // necessary for places input
//     }

// });
export {
	SlotForm,
	SlickAnimation,
	StickyHeader,
	Slick,
	Carousel3d,
	VueTranslate,
	VueWindowSize,
	VeeValidate,
	VueSweetalert2,
	ServicesSlider,
	CategoriesSlider,
	Sponsers,
	About,
	Projects,
	Usage,
	Addresses,
	News,
	CategoriesPage,
	MerchantsPage,
	MerchantsSlider,
	Products,
	MerchantsProducts,
	Login,
	Register,
	Reset,
	NumberInput,
	ChooseColor,
	ProjectsPage,
	ProjectSlider,
	UserProfile,
	UserProducts,
	MerchantProfile,
	MerchantOrders,
	RepeaterColor,
	AddService,
	SharePage,
	Dropzone,
	MobileHeader,
	Alert,
	SearchHeader,
	DatePicker,
	TimePicker,
	SearchPage,
	BookNow,
	Notifications
	

 // 	Collapse,
 // 	CollapseItem,
 // 	Slick,
 // 	StarRating,
 // 	Tabs,
 // 	TabPane,
 // 	GoogleMap,
 // 	SearchModal,
 // 	SlideOut,
 // 	AddMap,
 // 	NumberInput,
 // 	swiper,
 // 	swiperSlide,
 // 	Messages,
 // 	SlotForm,
 // 	CopyLink,
 // 	VueSlideBar,
 // 	Loader,
 // 	BrandFilter,
	// CategoryFilter,
 // 	Register,
 // 	Profile,
	//  Newsletter,
	//  Comments,
	//  OfferFilter,
	//  Search,
	//  SearchResults,
	//  AddRate,
	//  AddAddress,
	//  Checkout,
	//  MobileSearchResults
}
const app = new Vue({
	el: '#app',
	components: {
		SlotForm,
		SlickAnimation,
		StickyHeader,
		Slick,
		Carousel3d,
		VueTranslate,
		VueWindowSize,
		VeeValidate,
		VueSweetalert2,
		ServicesSlider,
		CategoriesSlider,
		Sponsers,
		About,
		Projects,
		Usage,
		Addresses,
		News,
		CategoriesPage,
		MerchantsPage,
		MerchantsSlider,
		Products,
		MerchantsProducts,
		Login,
		Register,
		Reset,
		NumberInput,
		ChooseColor,
		ProjectsPage,
		ProjectSlider,
		UserProfile,
		UserProducts,
		MerchantProfile,
		MerchantOrders,
		RepeaterColor,
		AddService,
		SharePage,
		Dropzone,
		MobileHeader,
		Alert,
		SearchHeader,
		DatePicker,
		TimePicker,
		SearchPage,
		BookNow,
		Notifications
		
 	// 	Collapse,
 	// 	CollapseItem,
 	// 	Slick,
 	// 	StarRating,
 	// 	Tabs,
 	// 	TabPane,
 	// 	GoogleMap,
 	// 	SearchModal,
 	// 	SlideOut,
 	// 	AddMap,
 	// 	NumberInput,
 	// 	swiper,
 	// 	swiperSlide,
 	// 	Messages,
 	// 	SlotForm,
 	// 	CopyLink,
 	// 	VueSlideBar,
 	// 	Loader,
 	// 	BrandFilter,
 	// 	CategoryFilter,
 	// 	Register,
 	// 	Profile,
		// Newsletter,
		// Comments,
		// OfferFilter,
		// Search,
		// SearchResults,
		// AddRate,
		// AddAddress,
		// Checkout,
		// MobileSearchResults
	}
});
